import React, { useEffect, FunctionComponent, useContext, useRef } from 'react';
import Loading from 'components/Loading';
import { useHistory, useLocation } from 'react-router';
import UsuarioDTO from 'models/UsuarioDTO';
import { RoleEnum } from 'enums/RoleEnum';
import { AccessPermissionContext } from 'core/context/AccessPermissionContext';
import useUserData from 'hooks/useUserData';
import { possuiRedirecionamentoPosLogin } from 'core/util/StorageRedirectRulesHelper';
import { useDispatch } from 'react-redux';
import { ProfileService } from 'core/http/service/Profile.service';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import * as profileActions from '../store/actions/Profile';
import { limparOrigemCadastro } from 'core/util/OrigemCadastroHelper';

const Login: FunctionComponent = ({ ...props }) => {
    const { redirectBehindRegister } = useContext(AccessPermissionContext.Context);

    const hiddenButtonRef = useRef<HTMLButtonElement>(null);
    const profileService = new ProfileService();
    const isLoggedin: Boolean = useAppSelector(state => state.profileReducer.isLoggedin);

    const { loadData } = useUserData();
    const history = useHistory();

    const dispatch = useDispatch();

    const location: any = useLocation();

    const getPathToRedirect = (): string => {
        const redirectParam = new URLSearchParams(location.search).get('redirect');
        const legacyRedirect = location.search.slice(1);
        const requestedPath = redirectParam || (legacyRedirect.startsWith('/') ? legacyRedirect : location.state?.pathToRedirect);

        if (!requestedPath || !requestedPath.startsWith('/') || requestedPath.startsWith('//')) {
            return '';
        }

        try {
            const redirectUrl = new URL(requestedPath, window.location.origin);
            if (redirectUrl.origin !== window.location.origin) return '';
            return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
        } catch {
            return '';
        }
    };

    const initialize = async () => {
        const { usuarioLogado, perfilUsuario } = await loadData();
        if (usuarioLogado) {
            // The origin only matters for new registrations
            if (perfilUsuario && perfilUsuario.codigo > 0) limparOrigemCadastro();

            if (await isAdmin(usuarioLogado)) {
                if (getPathToRedirect().length && getPathToRedirect() !== '/login') {
                    history.push(getPathToRedirect());
                } else {
                    history.push('/admin');
                }
            } else if (getPathToRedirect().length && getPathToRedirect() !== '/login') {
                redirectBehindRegister(getPathToRedirect());
            } else if (possuiRedirecionamentoPosLogin() && perfilUsuario) {
                //redirecionarCursoLivrePosLogin(hiddenButtonRef);
                if (perfilUsuario?.codigo === -1) {
                    history.push({
                        pathname: '/profile/informacoes',
                        state: { postProfilePath: getPathToRedirect() },
                    });
                } else {
                    redirectBehindRegister('/');
                }
            } else {
                if (perfilUsuario?.codigo === -1) {
                    history.push({
                        pathname: '/profile/informacoes',
                        state: { postProfilePath: getPathToRedirect() },
                    });
                } else {
                    redirectBehindRegister('/');
                }
            }

            if (!isLoggedin && perfilUsuario?.codigo) {
                registrarLogLogin(perfilUsuario.codigo);
                dispatch(profileActions.setIsLogaded(true));
            }
        }
    };

    const registrarLogLogin = async (idPerfil: number) => {
        if (idPerfil > 0) {
            await profileService.registrandoLogin(idPerfil);
        }
        return;
    };

    const isAdmin = async (usuarioLogado: UsuarioDTO) => {
        let retorno: boolean = false;
        usuarioLogado.roles?.forEach(role => {
            if (role === RoleEnum.Administrador) {
                retorno = true;
            }
        });
        return retorno;
    };

    useEffect(() => {
        initialize();
    }, []);

    return (
        <>
            <button ref={hiddenButtonRef} style={{ display: 'none' }}></button>
            {isLoggedin && <Loading />}
        </>
    );
};

export default Login;
